import './style.scss'
import { Button } from 'antd'
import { FC, memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import * as Api from '@/api/account'
import IconActivity from '@/assets/activity.gif'
import ActivityModal from '@/components/ActivityModal'
import UserCredits from '@/components/UserCredits'
import { IProduct, UserStore } from '@/global-states'
import { eventTracking } from '@/libs/util'

interface IProps {
  title?: string
}

const LayoutHeader: FC<IProps> = (props) => {
  const { userPackage, systemReady, systemGuideStep } = UserStore
  const { t: translate } = useTranslation(['layout'])
  const [activityModalOpen, setActivityModalOpen] = useState(false)
  const [productList, setProductList] = useState<IProduct[]>([])

  useEffect(() => {
    if (systemReady) {
      getData()
    }
  }, [systemReady])

  const getData = async () => {
    const res = await Api.getProductList()
    const list: IProduct[] = res?.list || []
    const activityProduct = list?.filter((p) => p.activity?.includes('activity'))
    setProductList(activityProduct || [])
    if (
      activityProduct?.length &&
      !sessionStorage.getItem('activity') &&
      !location.href.includes('setting') &&
      !systemGuideStep
    ) {
      setActivityModalOpen(true)
    }
  }

  const switchVersion = async () => {
    await eventTracking('SwitchToOldVersion')
    const token = UserStore.getToken() || ''
    let param = ''
    if (token.length > 12) {
      param = `/?token=${token}`
    }
    if (location.href.includes('dev')) {
      location.replace(`https://light-dev.hifly.cc${param}`)
    } else {
      location.replace(`https://light.hifly.cc${param}`)
    }
  }

  return (
    <div className="layout-header">
      <div className="layout-header-main">
        {!!productList?.length && (
          <img
            className="icon-activity"
            src={IconActivity}
            onClick={() => {
              eventTracking('ActivityIconClick-618')
              setActivityModalOpen(true)
            }}
          />
        )}

        <Button className="switch" onClick={switchVersion}>
          {translate('layout.switch_old_version')}
        </Button>

        <UserCredits />
      </div>

      <ActivityModal
        open={activityModalOpen}
        onCancel={() => {
          setActivityModalOpen(false)
        }}
      />
    </div>
  )
}

export default memo(LayoutHeader)
